// extracted by mini-css-extract-plugin
module.exports = {"badge":"CreditCardBadge_badge__vIkTK"};